// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"5512ea32","598":"8be94c31"}[chunkId] + ".chunk.js";
};